import { useEffect, useState } from 'react';
import api from 'api/axios';
import NotFound from 'pages/extra-pages/NotFound';

export default function WhitelistGate({ children }) {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        await api.get('/api/whitelist/all/1/1');

        if (!alive) return;
        setAllowed(true);
      } catch (e) {
        if (!alive) return;

        const status = e?.response?.status;

        if (status === 403) {
          setAllowed(false);
        } else if (status === 401) {
          setAllowed(true);
        } else {
          setAllowed(false);
        }
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (loading) return null;
  if (!allowed) return <NotFound />;

  return children;
}
